import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {

    const config = useRuntimeConfig();

    nuxtApp.provide('imgUrl', (url: string) => {

        if (url.startsWith('blob')) {
            return url;
        }

        return config.public.imgUrl + url
    })
})
